/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_8d651b9e{background:blue}\n"}]);
export const dummy = "dummy_8d651b9e";